export default __webpack_public_path__ + "static/loja-2-3c24d707f1d87ae0762ef839224cd769.png";